<div class="d-flex align-items-center flex-wrap gap-3 mb-4">
  <!-- Camera -->
  <div
    class="d-flex align-items-center flex-nowrap"
    style="cursor: pointer;"
    (click)="cameraInput.click()"
  >
    <img
      src="assets/icons/kamera_blue.svg"
      alt="Camera icon"
      style="width: 32px; height: auto; margin-right: 8px; flex-shrink: 0;"
    />
    <span class="text-nowrap">Take a picture</span>
    <input
      #cameraInput
      type="file"
      accept="image/*"
      capture="environment"
      (change)="handleImageUpload($event)"
      style="display: none;"
    />
  </div>

  <!-- Gallery -->
  <div
    class="d-flex align-items-center flex-nowrap"
    style="cursor: pointer;"
    (click)="galleryInput.click()"
  >
    <img
      src="assets/icons/image_blue.svg"
      alt="Gallery icon"
      style="width: 32px; height: auto; margin-right: 8px; flex-shrink: 0;"
    />
    <span class="text-nowrap">Choose from gallery</span>
    <input
      #galleryInput
      type="file"
      accept="image/*"
      (change)="handleImageUpload($event)"
      style="display: none;"
    />
  </div>
</div>
